exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* PatientProfileForm Style Sheet - KardiaPro */\n\n._3ApwPWS1sPfrnrQTEjpyKl{\n    font-style: normal;\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 23px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    letter-spacing: 0.25px;\n    padding: 2rem 0rem;\n    color: #142A39;\n}\n\n._3h527gdK_JAx4xtR7-06sL {\n    width: 100%;\n    border: 1px solid #142a396c;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    border-radius: 4px;\n    height: 40px;\n    padding: 10px;\n}\n\n._3beIJxZITp6fo2CN8b_Moa{\n    padding-bottom: 2rem;\n}", ""]);

// exports
exports.locals = {
	"title": "_3ApwPWS1sPfrnrQTEjpyKl",
	"testInput": "_3h527gdK_JAx4xtR7-06sL",
	"pageContainer": "_3beIJxZITp6fo2CN8b_Moa"
};


//////////////////
// WEBPACK FOOTER
// /Users/smotley795/Source/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/Users/smotley795/Source/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/components/PatientProfileForm/PatientProfileForm.styles.module.css
// module id = 10598
// module chunks = 23